import { DataGrid } from '@mui/x-data-grid';
import { Button, CircularProgress, Typography } from '@mui/material';
import { useMemo } from 'react';
import { DataGridStyle } from '../../shared/sharedStyles';
import { getUserFullName } from '../../utils/user.utils';

export const UserGroupTable = ({ lngsltd, data, filteredData, handleEdit, handleDelete, userData, groupData }) => {
    const columns = useMemo(() => {
        return [
            { field: 'id', headerName: '#', width: 70, headerAlign: 'center', align: 'center' },
            {
                field: 'user', headerName: lngsltd["User"], width: 200, headerAlign: 'center', align: 'center',
                renderCell: (params) => (
                    <div
                        style={{
                            width: '100%',
                            textAlign: 'center',
                            whiteSpace: 'normal',
                            wordBreak: 'break-word',
                        }}
                    >
                        {params.value}
                    </div>
                )
            },
            {
                field: 'group', headerName: lngsltd["Group"], width: 300, headerAlign: 'center', align: 'center',
                renderCell: (params) => (
                    <div
                        style={{
                            width: '100%',
                            textAlign: 'center',
                            whiteSpace: 'normal',
                            wordBreak: 'break-word',
                        }}
                    >
                        {params.value}
                    </div>
                )
            },
            {
                field: 'actions',
                headerName: lngsltd["Actions"],
                flex: 1,
                headerAlign: 'center',
                align: 'center',
                renderCell: (params) => (
                    <>
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            onClick={() => {
                                handleEdit(params.row)
                            }}
                            style={{ marginRight: 8 }}
                        >
                            {lngsltd["Edit"]}
                        </Button>
                        <Button
                            variant="outlined"
                            color="error"
                            size="small"
                            onClick={() => handleDelete(params.row.userID)}
                        >
                            {lngsltd["Delete"]}
                        </Button>
                    </>
                ),
            },
        ]
    }, [lngsltd, handleEdit, handleDelete]);

    const rows = useMemo(() => {

        const getUserById = (userId) => {
            const u = userData.find((x) => x.userID === userId);
            return u ? getUserFullName(u) : lngsltd[''];
        };

        const getGroupById = (groupId) => {
            const group = groupData.find((group) => group.groupID === groupId);
            return group ? group.groupName : null;
        };

        // 🔥 GROUP BY USERID
        const grouped = {};

        filteredData.forEach(item => {
            if (!grouped[item.userID]) {
                grouped[item.userID] = {
                    userID: item.userID,
                    userGroupIDs: [],
                    groupIDs: []
                };
            }

            grouped[item.userID].userGroupIDs.push(item.userGroupID);
            grouped[item.userID].groupIDs.push(item.groupID);
        });

        return Object.values(grouped).map((u, index) => ({
            id: index + 1,
            user: getUserById(u.userID),
            group: u.groupIDs
                .map(id => getGroupById(id))
                .filter(Boolean)
                .join(', '),
            userID: u.userID,
            groupIDs: u.groupIDs,
            userGroupIDs: u.userGroupIDs
        }));

    }, [filteredData, groupData, userData]);



    if (!filteredData.length) {
        return (
            <Typography variant="h6" align="center" sx={{ paddingTop: '25px' }}>
                <CircularProgress />
            </Typography>
        );
    }

    return (
        <DataGrid
            rows={rows}
            columns={columns}
            pageSize={5}
            rowsPerPageOptions={[5, 10, 25]}
            disableSelectionOnClick
            disableColumnResize
            getRowHeight={() => 'auto'}
            sx={{
                ...DataGridStyle,

                // Center all cells vertically
                '& .MuiDataGrid-cell': {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                },
            }}
        />
    );

}
